//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EventBus from "@/event-bus.js";
import { GET_ENCUESTAS_BY_PACIENTE_ID } from "@/graphql/queries/pacientes.js";
import { GET_PACIENTE_BY_COGNITO_ID } from "@/graphql/queries/pacientes.js";
import { REVISAR_ENCUESTA } from "@/graphql/mutations/encuestas.js";
import { contextualHelp } from "@/utils/contextualHelp.js";
import { date } from "quasar";

export default {
  name: "HistoricoEncuestasPacienteList",
  apollo: {
    encuestas: {
      query: GET_ENCUESTAS_BY_PACIENTE_ID,
      variables: {
        cognito_id: null
      },
      update(data) {
        if (data.findPacienteBy) {
          console.log(data.findPacienteBy);
          return data.findPacienteBy.encuestas;
        }
        return [];
      },
      skip() {
        return true;
      }
    },
    paciente: {
      query: GET_PACIENTE_BY_COGNITO_ID,
      variables: {
        cognito_id: null
      },
      update(data) {
        if (data.findPacienteBy) {
          console.log(data.findPacienteBy);
          return data.findPacienteBy;
        }
        return [];
      },
      skip() {
        return true;
      }
    }
  },
  mounted() {
    EventBus.$emit("page-loaded", { page: "HistoricoEncuestasPacienteList" });
    EventBus.$emit("dynamic-help", {
      help: contextualHelp["HistoricoEncuestasPacienteList"]
    });
    this.$apollo.queries.encuestas.setVariables({
      cognito_id: this.$route.params.id
    });
    this.$apollo.queries.paciente.setVariables({
      cognito_id: this.$route.params.id
    });
    this.$apollo.queries.encuestas.skip = false;
    this.$apollo.queries.paciente.skip = false;
    this.$apollo.queries.encuestas.refetch();
    this.$apollo.queries.paciente.refetch();
  },
  data() {
    return {
      encuestas: [],
      columns: [
        {
          name: "tipo_encuesta",
          label: "Tipo Encuesta",
          field: row => row.tipo_encuesta.descripcion,
          align: "left"
        },
        {
          name: "estado_encuesta_nombre",
          label: "Estado Encuesta",
          align: "left",
          field: row => row.estado_encuesta.nombre
        },
        {
          name: "fill_at",
          label: "Fecha de Realización",
          align: "left",
          field: row => this.computedDate(row.fill_at)
        },
        {
          name: "resultado",
          label: "Resultado",
          align: "left",
          field: "resultado"
        },
        {
          name: "resultado_numerico",
          label: "Resultado Numérico",
          align: "left",
          field: "resultado_numerico"
        },
        {
          name: "options",
          label: ""
        }
      ],
      paciente: {},
      selectedEncuesta: null,
      confirmarRevisionModal: false
    };
  },
  methods: {
    showConfirmRevisarEncuesta(row) {
      this.selectedEncuesta = row.id;
      this.confirmarRevisionModal = true;
    },
    async confirmarEncuesta() {
      try {
        let resultado = await this.$apollo.mutate({
          mutation: REVISAR_ENCUESTA,
          variables: {
            id_encuesta: this.selectedEncuesta
          }
        });
        console.log(resultado);
        this.$apollo.queries.encuestas.refetch();
        this.$q.notify({
          position: "top-right",
          message: "La encuesta se ha revisado correctamente",
          color: "positive"
        });
      } catch (e) {
        this.$q.notify({
          position: "top-right",
          message: "Ha habido un error al revisar la encuesta",
          color: "negative"
        });
      }
    },
    readEncuesta(row) {
      switch (row.tipo_encuesta.tipo) {
        case "RAPID3":
          this.$router.push({
            path: `/encuestas/${row.id}/rapid3`,
            query: { readOnly: true }
          });
          return;
      }
    },
    computedDate(d) {
      const comDat = d ? date.extractDate(d, "YYYY-MM-DD HH:mm:ss") : null;
      return comDat ? date.formatDate(comDat, "DD/MM/YYYY HH:mm") : "-";
    },
    calculateRowColor(row) {
      switch (row.estado_encuesta.nombre) {
        case "PENDIENTE":
          return "deep-orange";
        case "COMPLETADA":
          return "positive";
        case "REVISADA":
          return "primary";
      }
    },
    showBottomSheet(evt, row) {
      if (this.$q.screen.lt.md) {
        const actions = [];
        if (row.estado_encuesta.nombre === "COMPLETADA") {
          actions.push({
            label: "Marcar Encuesta como Revisada",
            icon: "check",
            id: "revisarEncuesta",
            classes: "custom-color-sheet"
          });
        }
        actions.push({
          label: "Ver Encuesta",
          icon: "history",
          id: "verEncuesta",
          classes: "custom-color-sheet"
        });
        this.$q
          .bottomSheet({
            message: "Seleccione una acción: ",
            grid: false,
            actions: actions
          })
          .onOk(action => {
            switch (action.id) {
              case "revisarEncuesta":
                this.showConfirmRevisarEncuesta(row);
                break;
              case "verEncuesta":
                this.readEncuesta(row);
                break;
            }
          });
      }
    }
  }
};
